/*
import showToastify from '../utils/toastify';
import "toastify-js/src/toastify.css"
import axios from 'axios'

export default function newsletter() {
  const btnSubmit2 = document.querySelector("#newsletter-form button[type=submit]");
  const newsletter = document.querySelector('#newsletter-form')


  function newsletterForm() {


    function showMessage(response) {
      const message = response.data ? response.data.message : response.message;

      const toast = document.createElement("div");
      toast.innerText = message;
      toast.style.position = "fixed";
      toast.style.top = "50%";
      toast.style.left = "50%";
      toast.style.transform = "translate(-50%, -50%)";
      toast.style.background = "#4BB543";
      toast.style.color = "#fff";
      toast.style.padding = "1rem 2rem";
      toast.style.borderRadius = "8px";
      toast.style.fontSize = "16px";
      toast.style.zIndex = "9999";
      toast.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.3)";
      toast.style.opacity = "1";
      toast.style.transition = "opacity 0.3s ease";

      document.body.appendChild(toast);

      setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 300); // remove após fade
      }, 4000);

      newsletter.reset();
      setTimeout(() => enabledBtn(btnSubmit), 1000);
    }

    function disabledBtn(btn) {
      btn.disabled = true;
      btn.classList.add("disabled");
    }

    function enabledBtn(btn) {
      btn.disabled = false;
      btn.classList.remove("disabled");
    }

    newsletter.addEventListener('submit', (e) => {
      e.preventDefault()
      disabledBtn(btnSubmit2);

      const form_data = {

        email: document.querySelector('#newsletter-form input[name=email]').value,

      };
      const url = "/newsletter/";
      axios.post(url, form_data)
        .then((response) => showMessage(response))
        .catch((response) => showMessage(response));
    })
  }

  if (newsletter) {
    console.log('aaaaaaaa', newsletter)
    newsletterForm()
  }

}
*/

import showToastify from '../utils/toastify';
import "toastify-js/src/toastify.css";
import axios from 'axios';

export default function newsletter() {
  const btnSubmit2 = document.querySelector("#newsletter-form button[type=submit]");
  const newsletter = document.querySelector('#newsletter-form');

  if (!newsletter) return;

  function showMessage(response) {
    const message = response?.data?.message || response?.message || 'Erro ao enviar.';

    const toast = document.createElement("div");
    toast.innerText = message;
    toast.style.position = "fixed";
    toast.style.top = "50%";
    toast.style.left = "50%";
    toast.style.transform = "translate(-50%, -50%)";
    toast.style.background = "#4BB543";
    toast.style.color = "#fff";
    toast.style.padding = "1rem 2rem";
    toast.style.borderRadius = "8px";
    toast.style.fontSize = "16px";
    toast.style.zIndex = "9999";
    toast.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.3)";
    toast.style.opacity = "1";
    toast.style.transition = "opacity 0.3s ease";

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 4000);

    newsletter.reset();
    setTimeout(() => enabledBtn(btnSubmit2), 1000);
  }

  function disabledBtn(btn) {
    btn.disabled = true;
    btn.classList.add("disabled");
  }

  function enabledBtn(btn) {
    btn.disabled = false;
    btn.classList.remove("disabled");
  }

  function esperarRecaptcha() {
    return new Promise((resolve, reject) => {
      let tentativas = 0;
      const verificar = () => {
        if (window.grecaptcha && window.site_key) {
          return resolve(true);
        }
        tentativas++;
        if (tentativas > 30) return reject("reCAPTCHA não carregou.");
        setTimeout(verificar, 100);
      };
      verificar();
    });
  }

  async function gerarRecaptchaToken() {
    await esperarRecaptcha();
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(window.site_key, { action: 'submit' })
          .then(resolve)
          .catch(reject);
      });
    });
  }

	newsletter.addEventListener('submit', async (e) => {
    e.preventDefault();
    disabledBtn(btnSubmit2);

    try {
      const recaptchaToken = await gerarRecaptchaToken();

      if (!recaptchaToken) {
        showToastify('Erro ao verificar reCAPTCHA. Tente novamente.');
        enabledBtn(btnSubmit2);
        return;
      }

      const form_data = {
        email: document.querySelector('#newsletter-form input[name=email]').value,
        recaptcha_token: recaptchaToken,
      };

      const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]')?.value;

      const url = "/newsletter/";
      const response = await axios.post(url, form_data, {
        headers: {
          'X-CSRFToken': csrfToken,
        },
      });

      showMessage(response);

    } catch (err) {
      console.error("❌ Erro ao enviar formulário:", err);
      showToastify("Erro de segurança ao enviar. Tente novamente.");
      enabledBtn(btnSubmit2);
    }
  });
}

